module.exports = __webpack_public_path__ + "media/images/icons/da_assegnare_allenamento-3cf0b0e7734cf76a2143dffa5f4a8c83.svg";